import { RecordsTable } from 'dyl-components'
import React from 'react'
import TextHistoryHeader from './subcomponents/TextHistoryHeader'
import TextHistoryRow from './subcomponents/TextHistoryRow'
import "./index.scss"

export default function TextHistory({
    loading,
    activePage,
    onPageChange,
    messages, 
    messagesCount, 
    recipientOptions, 
    senderOptions, 
    selectedRecipients, 
    selectedSenders ,
    isSearchResultEmpty,
    isTableEmpty,
    onRowClick,
    onFilter,
    selectedRow,
    isTextTab
}) {
    return (
        <RecordsTable
            tableBodyClassName='TextTabTable'
            isTableLoading={loading}
            isSearchResultEmpty={isSearchResultEmpty}
            isTableEmpty={isTableEmpty}
            noBorder
            basic
            TableHeader={<TextHistoryHeader
                recipientOptions={recipientOptions}
                senderOptions={senderOptions}
                selectedRecipients={selectedRecipients}
                selectedSenders={selectedSenders}
                onFilter={onFilter}
            />}
            TableRows={[...messages].map(message => (
                <TextHistoryRow key={message.id} message={message} onRowClick={onRowClick} selectedRow={selectedRow} isTextTab={isTextTab} />
            ))}
            recordsCount={messagesCount}
            recordsName='Text'
            tableEmptyMessage={"No Texts to display"}
            activePage={activePage}
            onPageChange={onPageChange}
        />
    )
}
